import { render, staticRenderFns } from "./TemplateCard.vue?vue&type=template&id=c7375006&scoped=true&"
import script from "./TemplateCard.vue?vue&type=script&lang=js&"
export * from "./TemplateCard.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCard.vue?vue&type=style&index=0&id=c7375006&scoped=true&lang=css&"
import style1 from "./TemplateCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7375006",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7375006')) {
      api.createRecord('c7375006', component.options)
    } else {
      api.reload('c7375006', component.options)
    }
    module.hot.accept("./TemplateCard.vue?vue&type=template&id=c7375006&scoped=true&", function () {
      api.rerender('c7375006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/TemplateCard.vue"
export default component.exports